import React from 'react';

export const Experience = ({ data }) => {
  
  const renderExperience = (companies) => {
    return companies.map((company, i) => {
      return (
        <div key={`${company.company}-${i}`} className='col-sm-12'>
          <h4>{company.company}</h4>
          {company.title ? renderExperienceInfo(company) : ''}

          {company.subCompanies ? renderSubCompanies(company.subCompanies) : ''}

          {company.hasOwnProperty('description') ? renderDescription(company.description) : ''}
        </div>
      );
    });
  };

  const renderExperienceInfo = (experience) => {
    return (
      <p className={`info ${experience.subCompanies ? 'mb-0' : ''}`}>
        {experience.title} <span className="bullet">&bull;</span>{' '}
        <em className="date">{experience.years}</em>
      </p>
    )
  }

  const renderSubCompanies = (contracts) => {
    return contracts.map((contract, i) => {
      return (
        <p className="info col-md-12" key={`${contract.company}-${i}`}>
          {contract.company} <span className="bullet">&bull;</span>{' '}
          <em className="date">{contract.years}</em>
        </p>
      );
    });
  };

  const renderDescription = (description) => {
      return (
        <>
          <section className="description">
            <h5>Summary of Duties</h5>
            <ul>{renderDutiesList(description.duties)}</ul>
          </section>

          <section className="description">
            <h5>Hard Skills</h5>
            <ul>{renderSkillsList(description.skills)}</ul>
          </section>
        </>
      )
  }
  const renderDutiesList = (duties) => {
    return duties.map((duty, i) => {
      return (
        <li key={`duty-${i + 1}`}>
          <span className="bullet">&bull;</span> {duty}
        </li>
      );
    });
  };

  const renderSkillsList = (skills) => {
    return skills.map((skill, i) => {
      return (
        <li key={`skill-${i + 1}`}>
          <span className="bullet">&bull;</span> <strong>{skill.title}</strong>{' '}
          {skill.text}
        </li>
      );
    });
  };

  return (
    <div id="experience">
      <div className="container">
        <div className="section-title text-center">
          <h2>Experience</h2>
        </div>
        {data ? (
          <div>
            <div className="row section-info">
              <div className="col-md-3"></div>

              <div className="col-md-9">
                <div className="row item">
                  <div className="col-md-12">
                    {renderExperience(data.companies)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          'loading...'
        )}
      </div>
    </div>
  );
};
